// extracted by mini-css-extract-plugin
export default {"tree":"tree-PoMp"};